<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <detail-list :col="1">
          <detail-list-item :term="$t('异常账户')">{{model.expectionUser}}</detail-list-item>
          <detail-list-item :term="$t('异常类型')">{{model.expectionType==0?$t('登录ip异常'):$t('账户异常')}}</detail-list-item>
          <detail-list-item :term="$t('异常客户端操作系统')">{{model.expectionOs}}</detail-list-item>
          <detail-list-item :term="$t('异常ip')">{{model.expectionIp}}</detail-list-item>
          <detail-list-item :term="$t('异常城市')">{{model.expectionCity}}</detail-list-item>
          <detail-list-item :term="$t('异常浏览器')">{{model.expectionBrowser}}</detail-list-item>
          <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          <detail-list-item :term="$t('异常描述')">{{model.expectionDescription}}</detail-list-item>
        </detail-list>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'AccountExceptionListModal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          queryById: "/sys/userExpectionRecord/edit",
        },
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules() {
        return {
          readState: {require: true,message:this.$t('请选择是否查看'),trigger: 'change'}
        }
      },
    },
    methods: {
      init(row) {
        let that = this;
        this.title = this.$t('详情');
        this.visible = true;
        this.model = row;
      },
      close() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        this.$refs.form.validate(valid => {
          if(valid){
            postAction(this.url.queryById,this.model).then(res => {
              if(res.success){
                this.$message.success(res.message);
                this.close();
              }
            });
          }
        })
      }
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>